import * as React from "react";
import { Component } from "react";
import { Pager } from "react-bootstrap";
import { Redirect } from "react-router";
import LoadingStatus from "src/components/common/LoadingStatus";
import AdvancedDualRateStatement from "src/components/projects/project/statements/advanced/dualrate/AdvancedDualRateStatement";
import { IServiceCharge } from "src/components/projects/project/statements/advanced/interfaces";
import StatementNavbar from "src/components/projects/project/statements/StatementNavbar";
import { IPdfPage, round, TIMEOUT } from "src/global";
import fs from "src/services/config/fbConfig";
import { sumServiceCharges, sumTaxesAndFees } from "../AdvancedStatementFunctions";
import { importAPSStatementData } from "./APSStatementImporter";
import {
  IAdvancedDualRateStatementPageProps,
  IAdvancedDualRateStatementPageState,
} from "./interfaces";

export default class AdvancedDualRateStatementPage extends Component<
  IAdvancedDualRateStatementPageProps,
  IAdvancedDualRateStatementPageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  private statementDocument: firebase.firestore.DocumentReference;
  private priorStatementDocument: firebase.firestore.DocumentReference | null;
  private simpleStatementDocument: firebase.firestore.DocumentReference;
  private advancedStatementDocument: firebase.firestore.DocumentReference;
  private priorAdvancedStatementDocument: firebase.firestore.DocumentReference | null;
  private serviceChargesCollection: firebase.firestore.CollectionReference;
  private taxesAndFeesCollection: firebase.firestore.CollectionReference;
  private unsubscribeServiceCharges: any;
  private unsubscribeTaxesAndFees: any;
  public constructor(props: IAdvancedDualRateStatementPageProps) {
    super(props);

    this.state = {
      loading: true,
      needsSaving: false,
      serviceStartDate: Date.now(),
      serviceEndDate: Date.now(),
      statementDate: Date.now(),
      yearsWithSolar: 0,
      totalAmountDue: 0,
      gridReadDate: Date.now(),
      gridReading: 0,
      priorGridReadDate: Date.now(),
      priorGridReading: 0,
      onPeakGridReadDate: Date.now(),
      onPeakGridReading: 0,
      priorOnPeakGridReadDate: Date.now(),
      priorOnPeakGridReading: 0,
      solarReadDate: Date.now(),
      solarReading: 0,
      priorSolarReadDate: Date.now(),
      priorSolarReading: 0,
      onPeakSolarReadDate: Date.now(),
      onPeakSolarReading: 0,
      priorOnPeakSolarReadDate: Date.now(),
      priorOnPeakSolarReading: 0,
      solarGenerated: 0,
      onPeakCredits: 0,
      offPeakCredits: 0,
      serviceCharges: [],
      taxesAndFees: [],
      allowStatementParsing: false,
      allowStatementUpload: false,
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
      importing: false,
      notes: "",
      netElectricityCredit: NaN,
      priorDataEditable: false,
      priorId: undefined,
      nextId: undefined,
    };

    this.renderStatementNavbar = this.renderStatementNavbar.bind(this);

    this.handleNotesChanged = this.handleNotesChanged.bind(this);
    this.handleServiceStartDateChanged = this.handleServiceStartDateChanged.bind(this);
    this.handleServiceEndDateChanged = this.handleServiceEndDateChanged.bind(this);

    this.handleStatementDateChanged = this.handleStatementDateChanged.bind(this);
    this.handleYearsWithSolarChanged = this.handleYearsWithSolarChanged.bind(this);
    this.handleTotalAmountDueChanged = this.handleTotalAmountDueChanged.bind(this);
    this.handleNetElectricityCreditChanged = this.handleNetElectricityCreditChanged.bind(this);

    this.handleGridReadDateChanged = this.handleGridReadDateChanged.bind(this);
    this.handleGridReadingChanged = this.handleGridReadingChanged.bind(this);
    this.handlePriorGridReadDateChanged = this.handlePriorGridReadDateChanged.bind(this);
    this.handlePriorGridReadingChanged = this.handlePriorGridReadingChanged.bind(this);

    this.handleOnPeakGridReadDateChanged = this.handleOnPeakGridReadDateChanged.bind(this);
    this.handleOnPeakGridReadingChanged = this.handleOnPeakGridReadingChanged.bind(this);
    this.handlePriorOnPeakGridReadDateChanged = this.handlePriorOnPeakGridReadDateChanged.bind(
      this
    );
    this.handlePriorOnPeakGridReadingChanged = this.handlePriorOnPeakGridReadingChanged.bind(this);

    this.handleSolarReadDateChanged = this.handleSolarReadDateChanged.bind(this);
    this.handleSolarReadingChanged = this.handleSolarReadingChanged.bind(this);
    this.handlePriorSolarReadDateChanged = this.handlePriorSolarReadDateChanged.bind(this);
    this.handlePriorSolarReadingChanged = this.handlePriorSolarReadingChanged.bind(this);

    this.handleOnPeakSolarReadDateChanged = this.handleOnPeakSolarReadDateChanged.bind(this);
    this.handleOnPeakSolarReadingChanged = this.handleOnPeakSolarReadingChanged.bind(this);
    this.handlePriorOnPeakSolarReadDateChanged = this.handlePriorOnPeakSolarReadDateChanged.bind(
      this
    );
    this.handlePriorOnPeakSolarReadingChanged = this.handlePriorOnPeakSolarReadingChanged.bind(
      this
    );

    this.handleSolarGeneratedChanged = this.handleSolarGeneratedChanged.bind(this);

    this.handleOnPeakCreditsChanged = this.handleOnPeakCreditsChanged.bind(this);
    this.handleOffPeakCreditsChanged = this.handleOffPeakCreditsChanged.bind(this);

    this.addServiceCharge = this.addServiceCharge.bind(this);
    this.deleteServiceCharge = this.deleteServiceCharge.bind(this);
    this.updateServiceCharge = this.updateServiceCharge.bind(this);
    this.copyPriorServiceCharges = this.copyPriorServiceCharges.bind(this);
    this.updateServiceCharges = this.updateServiceCharges.bind(this);

    this.addTaxAndFee = this.addTaxAndFee.bind(this);
    this.deleteTaxAndFee = this.deleteTaxAndFee.bind(this);
    this.updateTaxAndFee = this.updateTaxAndFee.bind(this);
    this.copyPriorTaxesAndFees = this.copyPriorTaxesAndFees.bind(this);

    this.updateTaxesAndFees = this.updateTaxesAndFees.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.saveData = this.saveData.bind(this);

    this.handleFilenameChanged = this.handleFilenameChanged.bind(this);
    this.deleteUploadedStatement = this.deleteUploadedStatement.bind(this);
    this.setStoragePath = this.setStoragePath.bind(this);
    this.setUploadStatus = this.setUploadStatus.bind(this);

    this.importPDFData = this.importPDFData.bind(this);
  }

  public componentWillMount() {
    const { appService } = this.props;
    const projectId = appService.getActiveProjectId();
    this.projectDocument = fs.fs.collection("projects").doc(projectId);
    this.statementDocument = this.projectDocument
      .collection("statements")
      .doc(this.props.match.params.id);
    this.advancedStatementDocument = this.projectDocument
      .collection("advancedDualRateStatements")
      .doc(this.props.match.params.id);
    this.simpleStatementDocument = this.projectDocument
      .collection("simpleDualRateStatements")
      .doc(this.props.match.params.id);
    this.serviceChargesCollection = this.advancedStatementDocument.collection("serviceCharges");
    this.taxesAndFeesCollection = this.advancedStatementDocument.collection("taxesAndFees");
    this.unsubscribeServiceCharges = this.serviceChargesCollection
      .orderBy("timestamp")
      .onSnapshot(this.updateServiceCharges);
    this.unsubscribeTaxesAndFees = this.taxesAndFeesCollection
      .orderBy("timestamp")
      .onSnapshot(this.updateTaxesAndFees);
    if (this.props.match.params.priorId !== undefined) {
      this.priorStatementDocument = this.projectDocument
        .collection("statements")
        .doc(this.props.match.params.priorId);
      this.priorAdvancedStatementDocument = this.projectDocument
        .collection("advancedDualRateStatements")
        .doc(this.priorStatementDocument.id);
    } else {
      this.priorStatementDocument = null;
      this.priorAdvancedStatementDocument = null;
    }
  }

  public componentDidMount() {
    let useNextId: boolean = false;
    let lastId: string | undefined;
    this.projectDocument
      .collection("statements")
      .orderBy("statementDate")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            if (useNextId) {
              useNextId = false;
              this.setState({ nextId: doc.id });
            }
            if (doc.id === this.props.match.params.id) {
              useNextId = true;
            }
            if (doc.id === this.props.match.params.priorId) {
              this.setState({ priorId: lastId });
            }
            lastId = doc.id;
          }
        });
      })
      .then(() => {
        this.projectDocument
          .get()
          .then(doc => {
            if (doc.exists) {
              const {
                allowStatementUpload,
                allowStatementParsing,
                priorDataEditable,
              } = doc.data() as any;
              this.setState({
                allowStatementUpload: allowStatementUpload ? allowStatementUpload : false,
                allowStatementParsing: allowStatementParsing ? allowStatementParsing : false,
                priorDataEditable: priorDataEditable === undefined ? priorDataEditable : false,
              });
            }
          })
          .then(() => {
            this.statementDocument
              .get()
              .then(doc => {
                if (doc.exists) {
                  const {
                    serviceStartDate,
                    serviceEndDate,
                    statementDate,
                    yearsWithSolar,
                    totalAmountDue,
                    storagePath,
                    filename,
                    uploaded,
                    notes,
                  } = doc.data() as any;
                  this.setState({
                    serviceStartDate: serviceStartDate ? serviceStartDate : Date.now(),
                    serviceEndDate: serviceEndDate ? serviceEndDate : Date.now(),
                    statementDate: statementDate ? statementDate : Date.now(),
                    yearsWithSolar: yearsWithSolar ? yearsWithSolar : 0,
                    totalAmountDue: totalAmountDue ? totalAmountDue : 0,
                    storagePath: storagePath ? storagePath : "",
                    filename: filename ? filename : "",
                    uploaded: uploaded ? uploaded : false,
                    notes: notes ? notes : "",
                  });

                  if (storagePath && storagePath !== "") {
                    const storedFile = fs.fsStorage.ref().child(storagePath);
                    storedFile
                      .getMetadata()
                      .then(metaData => {
                        const filename = metaData.customMetadata.filename;
                        this.setState({ filename, uploaded: true });
                      })
                      .catch(error => {
                        console.log(error);
                      });
                  }
                }
              })
              .then(() => {
                this.simpleStatementDocument.get().then(simpleDoc => {
                  if (simpleDoc.exists) {
                    const { solarGenerated } = simpleDoc.data() as any;
                    this.setState({ solarGenerated });
                  }
                });
              })
              .then(() => {
                this.advancedStatementDocument
                  .get()
                  .then(doc => {
                    if (doc.exists) {
                      const {
                        gridReadDate,
                        gridReading,
                        onPeakGridReadDate,
                        onPeakGridReading,
                        priorGridReadDate,
                        priorGridReading,
                        priorOnPeakGridReaddate,
                        priorOnPeakGridReading,
                        solarReadDate,
                        solarReading,
                        onPeakSolarReadDate,
                        onPeakSolarReading,
                        priorSolarReadDate,
                        priorSolarReading,
                        priorOnPeakSolarReadDate,
                        priorOnPeakSolarReading,
                        onPeakCredits,
                        offPeakCredits,
                        netElectricityCredit,
                      } = doc.data() as any;

                      this.setState({
                        gridReadDate: gridReadDate ? gridReadDate : Date.now(),
                        gridReading: gridReading ? gridReading : 0,
                        priorGridReadDate: priorGridReadDate ? priorGridReadDate : Date.now(),
                        priorGridReading: priorGridReading ? priorGridReading : 0,
                        onPeakGridReadDate: onPeakGridReadDate ? onPeakGridReadDate : Date.now(),
                        onPeakGridReading: onPeakGridReading ? onPeakGridReading : 0,
                        priorOnPeakGridReadDate: priorOnPeakGridReaddate
                          ? priorOnPeakGridReaddate
                          : Date.now(),
                        priorOnPeakGridReading: priorOnPeakGridReading ? priorOnPeakGridReading : 0,
                        solarReadDate: solarReadDate ? solarReadDate : Date.now(),
                        solarReading: solarReading ? solarReading : 0,
                        onPeakSolarReadDate: onPeakSolarReadDate ? onPeakSolarReadDate : Date.now(),
                        onPeakSolarReading: onPeakSolarReading ? onPeakSolarReading : 0,
                        priorSolarReadDate: priorSolarReadDate ? priorSolarReadDate : Date.now(),
                        priorSolarReading: priorSolarReading ? priorSolarReading : 0,
                        priorOnPeakSolarReadDate: priorOnPeakSolarReadDate
                          ? priorOnPeakSolarReadDate
                          : Date.now(),
                        priorOnPeakSolarReading: priorOnPeakSolarReading
                          ? priorOnPeakSolarReading
                          : 0,
                        onPeakCredits: onPeakCredits ? onPeakCredits : 0,
                        offPeakCredits: offPeakCredits ? offPeakCredits : 0,
                        netElectricityCredit: netElectricityCredit ? netElectricityCredit : NaN,
                      });
                    } else {
                      this.advancedStatementDocument.set({
                        gridReadDate: Date.now(),
                        gridReading: 0,
                        priorGridReadDate: Date.now(),
                        priorGridReading: 0,
                        onPeakGridReadDate: Date.now(),
                        onPeakGridReading: 0,
                        priorOnPeakGridReaddate: Date.now(),
                        priorOnPeakGridReading: 0,
                        solarReadDate: Date.now(),
                        solarReading: 0,
                        priorSolarReadDate: Date.now(),
                        priorSolarReading: 0,
                        onPeakSolarReadDate: Date.now(),
                        onPeakSolarReading: 0,
                        priorOnPeakSolarReadDate: Date.now(),
                        priorOnPeakSolarReading: 0,
                        onPeakCredits: 0,
                        offPeakCredits: 0,
                        netElectricityCredit: 0,
                      });
                    }
                  })
                  .then(() => {
                    if (this.priorAdvancedStatementDocument) {
                      this.priorAdvancedStatementDocument
                        .get()
                        .then(doc => {
                          if (doc.exists) {
                            const {
                              gridReadDate,
                              gridReading,
                              onPeakGridReadDate,
                              onPeakGridReading,
                              solarReadDate,
                              solarReading,
                              onPeakSolarReadDate,
                              onPeakSolarReading,
                              onPeakCredits,
                              offPeakCredits,
                            } = doc.data() as any;
                            this.setState({
                              priorGridReadDate: gridReadDate ? gridReadDate : Date.now(),
                              priorGridReading: gridReading ? gridReading : 0,
                              priorOnPeakGridReadDate: onPeakGridReadDate
                                ? onPeakGridReadDate
                                : Date.now(),
                              priorOnPeakGridReading: onPeakGridReading ? onPeakGridReading : 0,
                              priorSolarReadDate: solarReadDate ? solarReadDate : Date.now(),
                              priorSolarReading: solarReading ? solarReading : 0,
                              priorOnPeakSolarReadDate: onPeakSolarReadDate
                                ? onPeakSolarReadDate
                                : Date.now(),
                              priorOnPeakSolarReading: onPeakSolarReading ? onPeakSolarReading : 0,
                              onPeakCredits: onPeakCredits ? onPeakCredits : 0,
                              offPeakCredits: offPeakCredits ? offPeakCredits : 0,
                            });
                          }
                        })
                        .then(() => {
                          if (this.priorStatementDocument) {
                            this.priorStatementDocument.get().then(doc => {
                              const { serviceEndDate } = doc.data() as any;
                              this.setState({
                                serviceStartDate: serviceEndDate ? serviceEndDate : Date.now(),
                                priorGridReadDate: serviceEndDate ? serviceEndDate : Date.now(),
                                priorOnPeakGridReadDate: serviceEndDate
                                  ? serviceEndDate
                                  : Date.now(),
                                priorSolarReadDate: serviceEndDate ? serviceEndDate : Date.now(),
                                priorOnPeakSolarReadDate: serviceEndDate
                                  ? serviceEndDate
                                  : Date.now(),
                              });
                            });
                          }
                        });
                    }
                  });
              })
              .then(() => {
                const totalAmountDue = this.calculateTotalAmountDue();
                this.setState({
                  loading: false,
                  needsSaving: false,
                  totalAmountDue,
                });
              });
          });
      });
  }

  public componentWillUnmount() {
    this.unsubscribeServiceCharges(this.updateServiceCharges);
    this.unsubscribeTaxesAndFees(this.updateTaxesAndFees);
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.importing) {
      return <LoadingStatus text="Importing PDF Data..." />;
    }

    let priorStatementPath: string = "#";
    let nextStatementPath: string = "#";

    if (this.props.match.params.priorId && this.state.priorId) {
      priorStatementPath = `/advanceddualratestatement/${this.props.match.params.priorId}/${
        this.state.priorId
      }`;
    } else if (this.props.match.params.priorId && !this.state.priorId) {
      priorStatementPath = `/advanceddualratestatement/${this.props.match.params.priorId}`;
    }

    if (this.props.match.params.id && this.state.nextId) {
      nextStatementPath = `/advanceddualratestatement/${this.state.nextId}/${
        this.props.match.params.id
      }`;
    }

    return (
      <div className="container-fixed-navbar">
        {this.renderStatementNavbar()}
        <div className="container">
          <Pager>
            <Pager.Item
              previous={true}
              href={priorStatementPath}
              disabled={!this.props.match.params.priorId}
              // onClick={this.navigateToPreviousStatement}
            >
              &larr; Previous Statement
            </Pager.Item>
            <Pager.Item
              next={true}
              href={nextStatementPath}
              disabled={!this.state.nextId}
              // onClick={this.navigateToNextStatement}
            >
              Next Statement &rarr;
            </Pager.Item>
          </Pager>
        </div>
        <AdvancedDualRateStatement
          needsSaving={this.state.needsSaving}
          appService={this.props.appService}
          history={this.props.history}
          match={this.props.match}
          notes={this.state.notes}
          notesChanged={this.handleNotesChanged}
          serviceStartDate={this.state.serviceStartDate}
          serviceEndDate={this.state.serviceEndDate}
          serviceStartDateChanged={this.handleServiceStartDateChanged}
          serviceEndDateChanged={this.handleServiceEndDateChanged}
          statementDate={this.state.statementDate}
          yearsWithSolar={this.state.yearsWithSolar}
          totalAmountDue={this.state.totalAmountDue}
          netElectricityCredit={this.state.netElectricityCredit}
          netElectricityCreditChanged={this.handleNetElectricityCreditChanged}
          showNetElectricityCredit={!isNaN(this.state.netElectricityCredit)}
          statementDateChanged={this.handleStatementDateChanged}
          yearsWithSolarChanged={this.handleYearsWithSolarChanged}
          totalAmountDueChanged={this.handleTotalAmountDueChanged}
          gridReadDate={this.state.gridReadDate}
          gridReading={this.state.gridReading}
          onPeakGridReadDate={this.state.onPeakGridReadDate}
          onPeakGridReading={this.state.onPeakGridReading}
          gridReadDateChanged={this.handleGridReadDateChanged}
          gridReadingChanged={this.handleGridReadingChanged}
          onPeakGridReadDateChanged={this.handleOnPeakGridReadDateChanged}
          onPeakGridReadingChanged={this.handleOnPeakGridReadingChanged}
          priorGridReadDate={this.state.priorGridReadDate}
          priorGridReading={this.state.priorGridReading}
          priorOnPeakGridReadDate={this.state.priorOnPeakGridReadDate}
          priorOnPeakGridReading={this.state.priorOnPeakGridReading}
          priorGridReadDateChanged={this.handlePriorGridReadDateChanged}
          priorGridReadingChanged={this.handlePriorGridReadingChanged}
          priorOnPeakGridReadDateChanged={this.handlePriorOnPeakGridReadDateChanged}
          priorOnPeakGridReadingChanged={this.handlePriorOnPeakGridReadingChanged}
          solarReadDate={this.state.solarReadDate}
          solarReading={this.state.solarReading}
          priorSolarReadDate={this.state.priorSolarReadDate}
          priorSolarReading={this.state.priorSolarReading}
          onPeakSolarReadDate={this.state.onPeakSolarReadDate}
          onPeakSolarReading={this.state.onPeakSolarReading}
          priorOnPeakSolarReadDate={this.state.priorOnPeakSolarReadDate}
          priorOnPeakSolarReading={this.state.priorOnPeakSolarReading}
          solarReadingDateChanged={this.handleSolarReadDateChanged}
          solarReadingChanged={this.handleSolarReadingChanged}
          priorSolarReadingDateChanged={this.handlePriorSolarReadDateChanged}
          priorSolarReadingChanged={this.handlePriorSolarReadingChanged}
          onPeakSolarReadDateChanged={this.handleOnPeakSolarReadDateChanged}
          onPeakSolarReadingChanged={this.handleOnPeakSolarReadingChanged}
          priorOnPeakSolarReadDateChanged={this.handlePriorOnPeakSolarReadDateChanged}
          priorOnPeakSolarReadingChanged={this.handlePriorOnPeakSolarReadingChanged}
          solarGenerated={this.state.solarGenerated}
          solarGeneratedChanged={this.handleSolarGeneratedChanged}
          onPeakCredits={this.state.onPeakCredits}
          offPeakCredits={this.state.offPeakCredits}
          onPeakCreditsChanged={this.handleOnPeakCreditsChanged}
          offPeakCreditsChanged={this.handleOffPeakCreditsChanged}
          serviceCharges={this.state.serviceCharges}
          addServiceCharge={this.addServiceCharge}
          deleteServiceCharge={this.deleteServiceCharge}
          updateServiceCharge={this.updateServiceCharge}
          copyPriorServiceCharges={this.copyPriorServiceCharges}
          taxesAndFees={this.state.taxesAndFees}
          addTaxAndFee={this.addTaxAndFee}
          deleteTaxAndFee={this.deleteTaxAndFee}
          updateTaxAndFee={this.updateTaxAndFee}
          copyPriorTaxesAndFees={this.copyPriorTaxesAndFees}
          priorDataEditable={this.state.priorDataEditable}
        />
      </div>
    );
  }

  private renderStatementNavbar() {
    const brand = this.props.appService.getActiveProjectLocation();
    return (
      <StatementNavbar
        appService={this.props.appService}
        match={this.props.match}
        history={this.props.history}
        isAdvanced={true}
        allowStatementParsing={this.state.allowStatementParsing}
        allowStatementUpload={this.state.allowStatementUpload}
        brand={brand}
        file={this.state.file}
        filename={this.state.filename}
        handleFilenameChanged={this.handleFilenameChanged}
        importPDFData={this.importPDFData}
        setStoragePath={this.setStoragePath}
        needsSaving={this.state.needsSaving}
        storagePath={this.state.storagePath}
        saveData={this.saveData}
        deleteUploadedStatement={this.deleteUploadedStatement}
        uploaded={this.state.uploaded}
        setUploadStatus={this.setUploadStatus}
        priorDataEditable={this.state.priorDataEditable}
      />
    );
  }

  private handleSave(e: any) {
    e.preventDefault();
    this.saveData(this.state.needsSaving);
  }

  private saveData(needsSaving: boolean) {
    if (needsSaving) {
      this.setState({ loading: true });
      const totalElectricityFromGrid = this.state.gridReading - this.state.priorGridReading;
      const onPeakElectricityFromGrid =
        this.state.onPeakGridReading - this.state.priorOnPeakGridReading;
      const totalElectricityCredited = this.state.solarReading - this.state.priorSolarReading;
      const onPeakElectricityCredited =
        this.state.onPeakSolarReading - this.state.priorOnPeakSolarReading;
      let lastMonthOnPeakCredit =
        onPeakElectricityCredited + this.state.onPeakCredits - onPeakElectricityFromGrid;
      const offPeakElectricityCredited = totalElectricityCredited - onPeakElectricityCredited;
      const offPeakElectricityFromGrid = totalElectricityFromGrid - onPeakElectricityFromGrid;
      let lastMonthOffPeakCredit =
        offPeakElectricityCredited + this.state.offPeakCredits - offPeakElectricityFromGrid;

      if (this.props.match.params.priorId === undefined) {
        lastMonthOnPeakCredit = this.state.onPeakCredits;
        lastMonthOffPeakCredit = this.state.offPeakCredits;
      } else {
        if (lastMonthOnPeakCredit < 0) {
          lastMonthOnPeakCredit = 0;
        }
        if (lastMonthOffPeakCredit < 0) {
          lastMonthOffPeakCredit = 0;
        }
      }

      const solarGenerated = this.state.solarGenerated;
      this.statementDocument
        .update({
          serviceStartDate: this.state.serviceStartDate,
          serviceEndDate: this.state.serviceEndDate,
          statementDate: this.state.statementDate,
          yearsWithSolar: this.state.yearsWithSolar,
          totalAmountDue: this.state.totalAmountDue,
          storagePath: this.state.storagePath,
          filename: this.state.filename,
          uploaded: this.state.uploaded,
          notes: this.state.notes,
        })
        .then(() => {
          this.advancedStatementDocument
            .update({
              gridReadDate: Number(this.state.gridReadDate),
              gridReading: Number(this.state.gridReading),
              onPeakGridReadDate: Number(this.state.onPeakGridReadDate),
              onPeakGridReading: Number(this.state.onPeakGridReading),
              solarReadDate: Number(this.state.solarReadDate),
              solarReading: Number(this.state.solarReading),
              onPeakSolarReadDate: Number(this.state.onPeakSolarReadDate),
              onPeakSolarReading: Number(this.state.onPeakSolarReading),
              priorGridReadDate: Number(this.state.priorGridReadDate),
              priorGridReading: Number(this.state.priorGridReading),
              priorOnPeakGridReaddate: Number(this.state.priorOnPeakGridReadDate),
              priorOnPeakGridReading: Number(this.state.priorOnPeakGridReading),
              priorSolarReadDate: Number(this.state.priorSolarReadDate),
              priorSolarReading: Number(this.state.priorSolarReading),
              priorOnPeakSolarReadDate: Number(this.state.priorOnPeakSolarReadDate),
              priorOnPeakSolarReading: Number(this.state.priorOnPeakSolarReading),
              onPeakCredits: lastMonthOnPeakCredit,
              offPeakCredits: lastMonthOffPeakCredit,
              netElectricityCredit: Number(this.state.netElectricityCredit),
            })
            .then(() => {
              this.simpleStatementDocument.get().then(doc => {
                if (doc.exists) {
                  this.simpleStatementDocument.update({
                    totalElectricityFromGrid,
                    onPeakElectricityFromGrid,
                    totalElectricityCredited,
                    onPeakElectricityCredited,
                    lastMonthOnPeakCredit,
                    lastMonthOffPeakCredit,
                    solarGenerated,
                  });
                } else {
                  this.simpleStatementDocument.set({
                    id: doc.id,
                    totalElectricityFromGrid,
                    onPeakElectricityFromGrid,
                    totalElectricityCredited,
                    onPeakElectricityCredited,
                    lastMonthOnPeakCredit,
                    lastMonthOffPeakCredit,
                    solarGenerated,
                  });
                }
              });
            })
            .then(() => {
              this.setState({ loading: false, needsSaving: false });
            });
        });
    }
  }

  private handleStatementDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      statementDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleNotesChanged(value: any) {
    this.setState({ notes: value, needsSaving: true });
  }
  private handleServiceStartDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    const date = new Date(e.currentTarget.value).valueOf();
    this.setState({
      serviceStartDate: date,
      priorGridReadDate: date,
      priorOnPeakGridReadDate: date,
      priorSolarReadDate: date,
      priorOnPeakSolarReadDate: date,
      needsSaving: true,
    });
  }
  private handleServiceEndDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    const date = new Date(e.currentTarget.value).valueOf();
    this.setState({
      serviceEndDate: date,
      gridReadDate: date,
      onPeakGridReadDate: date,
      solarReadDate: date,
      onPeakSolarReadDate: date,
      needsSaving: true,
    });
  }
  private handleYearsWithSolarChanged(e: any): void {
    this.setState({
      yearsWithSolar: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleTotalAmountDueChanged(e: any): void {
    this.setState({
      totalAmountDue: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleNetElectricityCreditChanged(e: any): void {
    this.setState({
      netElectricityCredit: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }

  private handleGridReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      gridReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleGridReadingChanged(e: any): void {
    this.setState({
      gridReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleOnPeakGridReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      onPeakGridReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleOnPeakGridReadingChanged(e: any): void {
    this.setState({
      onPeakGridReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handlePriorGridReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      priorGridReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handlePriorGridReadingChanged(e: any): void {
    this.setState({
      priorGridReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handlePriorOnPeakGridReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      priorOnPeakGridReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handlePriorOnPeakGridReadingChanged(e: any): void {
    this.setState({
      priorOnPeakGridReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleSolarReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      solarReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleSolarReadingChanged(e: any): void {
    this.setState({
      solarReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handlePriorSolarReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      priorSolarReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handlePriorSolarReadingChanged(e: any): void {
    this.setState({
      priorSolarReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handlePriorOnPeakSolarReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      priorOnPeakSolarReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handlePriorOnPeakSolarReadingChanged(e: any): void {
    this.setState({
      priorOnPeakSolarReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleOnPeakSolarReadDateChanged(e: any): void {
    if (!e.currentTarget.value) {
      return;
    }
    this.setState({
      onPeakSolarReadDate: new Date(e.currentTarget.value).valueOf(),
      needsSaving: true,
    });
  }
  private handleOnPeakSolarReadingChanged(e: any): void {
    this.setState({
      onPeakSolarReading: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleSolarGeneratedChanged(e: any): void {
    this.setState({ solarGenerated: Number(e.currentTarget.value), needsSaving: true });
  }
  private handleOnPeakCreditsChanged(e: any): void {
    this.setState({
      onPeakCredits: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private handleOffPeakCreditsChanged(e: any): void {
    this.setState({
      offPeakCredits: Number(e.currentTarget.value),
      needsSaving: true,
    });
  }
  private addServiceCharge() {
    setTimeout(() => {
      this.serviceChargesCollection.add({
        timestamp: Date.now(),
        description: "",
        value: 0,
        unit: "kWh",
        rate: 0,
        totalCharge: 0,
      });
    }, 250);
    this.setState({ needsSaving: true });
  }
  private addTaxAndFee() {
    setTimeout(() => {
      this.taxesAndFeesCollection.add({
        timestamp: Date.now(),
        description: "",
        value: 0,
        unit: "Cost",
        rate: 0,
        totalCharge: 0,
      });
    }, 250);
  }
  private deleteServiceCharge(serviceCharge: IServiceCharge): void {
    this.serviceChargesCollection.doc(serviceCharge.id).delete();
    this.setState({ needsSaving: true });
  }
  private deleteTaxAndFee(serviceCharge: IServiceCharge): void {
    this.taxesAndFeesCollection.doc(serviceCharge.id).delete();
    this.setState({ needsSaving: true });
  }
  private updateServiceCharge(serviceCharge: IServiceCharge): void {
    serviceCharge.totalCharge = round(serviceCharge.value * serviceCharge.rate, 3);
    this.serviceChargesCollection
      .doc(serviceCharge.id)
      .update({
        description: serviceCharge.description,
        value: serviceCharge.value,
        unit: serviceCharge.unit,
        rate: serviceCharge.rate,
        totalCharge: serviceCharge.totalCharge,
      })
      .then(() => {
        const totalServiceCharges = sumServiceCharges(this.state.serviceCharges);
        const totalTaxesAndFees = sumTaxesAndFees(this.state.taxesAndFees);
        this.setState({
          totalAmountDue: totalServiceCharges + totalTaxesAndFees,
          needsSaving: true,
        });
      });
  }
  private updateTaxAndFee(serviceCharge: IServiceCharge): void {
    serviceCharge.totalCharge = round(serviceCharge.rate * serviceCharge.value, 3);
    this.taxesAndFeesCollection
      .doc(serviceCharge.id)
      .update({
        description: serviceCharge.description,
        value: serviceCharge.value,
        unit: serviceCharge.unit,
        rate: serviceCharge.rate,
        totalCharge: serviceCharge.totalCharge,
      })
      .then(() => {
        const totalServiceCharges = sumServiceCharges(this.state.serviceCharges);
        const totalTaxesAndFees = sumTaxesAndFees(this.state.taxesAndFees);
        this.setState({
          totalAmountDue: totalServiceCharges + totalTaxesAndFees,
          needsSaving: true,
        });
      });
  }
  private copyPriorServiceCharges(): void {
    if (this.priorAdvancedStatementDocument) {
      const priorServiceChargesCollection = this.priorAdvancedStatementDocument.collection(
        "serviceCharges"
      );
      let totalServiceCharges = 0;
      this.setState({ loading: true });
      priorServiceChargesCollection
        .orderBy("timestamp")
        .get()
        .then(querySnapshot =>
          querySnapshot.forEach(doc => {
            const { timestamp, description, value, unit, rate } = doc.data();
            const totalCharge = round(rate * value, 3);
            totalServiceCharges += round(totalCharge, 2);
            this.serviceChargesCollection.add({
              timestamp,
              description,
              value,
              unit,
              rate,
              totalCharge,
            });
          })
        )
        .then(() => {
          const totalTaxesAndFees = sumTaxesAndFees(this.state.taxesAndFees);
          this.setState({
            totalAmountDue: totalServiceCharges + totalTaxesAndFees,
            loading: false,
            needsSaving: true,
          });
        });
    }
  }
  private copyPriorTaxesAndFees(): void {
    if (this.priorAdvancedStatementDocument) {
      const priorServiceChargesCollection = this.priorAdvancedStatementDocument.collection(
        "taxesAndFees"
      );
      let totalTaxesAndFees = 0;
      this.setState({ loading: true });
      priorServiceChargesCollection
        .orderBy("timestamp")
        .get()
        .then(querySnapshot =>
          querySnapshot.forEach(doc => {
            const { timestamp, description, value, unit, rate } = doc.data();
            const totalCharge = round(rate * value, 3);
            totalTaxesAndFees += round(totalCharge, 2);
            this.taxesAndFeesCollection.add({
              timestamp,
              description,
              value,
              unit,
              rate,
              totalCharge,
            });
          })
        )
        .then(() => {
          const totalServiceCharges = sumServiceCharges(this.state.serviceCharges);
          this.setState({
            totalAmountDue: totalTaxesAndFees + totalServiceCharges,
            loading: false,
            needsSaving: true,
          });
        });
    }
  }
  private updateServiceCharges(querySnapshot: firebase.firestore.QuerySnapshot) {
    const serviceCharges: IServiceCharge[] = [];
    querySnapshot.forEach(doc => {
      const { timestamp, description, value, rate, unit, totalCharge } = doc.data();
      serviceCharges.push({
        id: doc.id,
        timestamp,
        description,
        value,
        rate,
        unit,
        totalCharge,
      });
    });
    const totalServiceCharges = sumServiceCharges(serviceCharges);
    const totalTaxesAndFees = sumTaxesAndFees(this.state.taxesAndFees);
    this.setState({
      serviceCharges,
      loading: false,
      totalAmountDue: totalServiceCharges + totalTaxesAndFees,
    });
  }
  private updateTaxesAndFees(querySnapshot: firebase.firestore.QuerySnapshot) {
    const taxesAndFees: IServiceCharge[] = [];
    querySnapshot.forEach(doc => {
      const { timestamp, description, value, rate, unit, totalCharge } = doc.data();
      taxesAndFees.push({
        id: doc.id,
        timestamp,
        description,
        value,
        unit,
        rate,
        totalCharge,
      });
    });
    const totalTaxesAndFees = sumTaxesAndFees(taxesAndFees);
    const totalServiceCharges = sumServiceCharges(this.state.serviceCharges);
    this.setState({
      taxesAndFees,
      loading: false,
      totalAmountDue: totalTaxesAndFees + totalServiceCharges,
    });
  }
  private calculateTotalAmountDue(): number {
    const totalServiceCharges = sumServiceCharges(this.state.serviceCharges);
    const totalTaxesAndFees = sumTaxesAndFees(this.state.taxesAndFees);
    return totalServiceCharges + totalTaxesAndFees;
  }

  private handleFilenameChanged(e: any) {
    const files: FileList = e.target.files;
    if (files) {
      const file: File = files[0];
      if (file) {
        this.setState({ file, filename: file.name });
      }
    }
  }

  private deleteUploadedStatement() {
    this.setState({
      file: null,
      filename: "",
      storagePath: "",
      uploaded: false,
    });
    this.saveData(true);
  }

  private importPDFData(pdfPages: IPdfPage[], importType: number): void {
    setTimeout(() => {
      this.setState({ importing: true });
      if (importType === 0) {
        this.state.taxesAndFees.forEach(taxAndFee => {
          this.taxesAndFeesCollection.doc(taxAndFee.id).delete();
        });

        this.state.serviceCharges.forEach(serviceCharge => {
          this.serviceChargesCollection.doc(serviceCharge.id).delete();
        });

        const {
          statementDate,
          priorGridReadDate,
          gridReadDate,
          gridReading,
          priorGridReading,
          solarReadDate,
          solarReading,
          priorSolarReadDate,
          priorSolarReading,
          onPeakGridReadDate,
          onPeakGridReading,
          priorOnPeakGridReadDate,
          priorOnPeakGridReading,
          onPeakSolarReadDate,
          onPeakSolarReading,
          priorOnPeakSolarReadDate,
          priorOnPeakSolarReading,
          onPeakCredits,
          offPeakCredits,
          netElectricityCredit,
          totalServiceCharges,
          totalTaxesAndFees,
        } = importAPSStatementData(
          this.props.match.params.priorId,
          pdfPages,
          this.state.priorOnPeakGridReadDate,
          this.state.priorOnPeakGridReading,
          this.state.priorOnPeakSolarReadDate,
          this.state.priorOnPeakSolarReading,
          this.state.priorGridReadDate,
          this.state.priorGridReading,
          this.state.priorSolarReadDate,
          this.state.priorSolarReading,
          this.serviceChargesCollection,
          this.taxesAndFeesCollection
        );

        setTimeout(() => {
          this.setState({
            statementDate,
            serviceStartDate: priorGridReadDate,
            serviceEndDate: gridReadDate,
            gridReadDate,
            gridReading,
            priorGridReadDate,
            priorGridReading,
            solarReadDate,
            solarReading,
            priorSolarReadDate,
            priorSolarReading,
            onPeakGridReadDate,
            onPeakGridReading,
            priorOnPeakGridReadDate,
            priorOnPeakGridReading,
            onPeakSolarReadDate,
            onPeakSolarReading,
            priorOnPeakSolarReadDate,
            priorOnPeakSolarReading,
            onPeakCredits,
            offPeakCredits,
            netElectricityCredit,
            importing: false,
            totalAmountDue: totalServiceCharges + totalTaxesAndFees,
            needsSaving: true,
          });
        }, TIMEOUT);
      }
    }, TIMEOUT);
  }

  private setStoragePath(storagePath: string, filename: string): void {
    this.setState({ storagePath, filename });
  }

  private setUploadStatus(uploaded: boolean): void {
    this.setState({ uploaded: true, needsSaving: true });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/statements/advanced/dualrate/AdvancedDualRateStatementPage.tsx